import api from './api';

export interface Document {
  id: string;
  wedding_id: string;
  filename: string;
  storage_path: string;
  content_type: string;
  size_bytes: number;
  topic_id: string | null;
  uploaded_at: string;
}

export const getDocuments = () => api.get<Document[]>('/documents');
export const uploadDocument = (file: File, topicId?: string | null) => {
  const formData = new FormData();
  formData.append('file', file);
  const params = topicId ? `?topic_id=${topicId}` : '';
  return api.post<Document>(`/documents${params}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const updateDocumentTopic = (id: string, topicId: string | null) =>
  api.patch<Document>(`/documents/${id}?topic_id=${topicId ?? ''}`);
export const downloadDocument = (id: string) =>
  api.get(`/documents/${id}`, { responseType: 'blob' });
export const deleteDocument = (id: string) => api.delete(`/documents/${id}`);
